'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMoreThan = exports.addDays = exports.getDaysSince = exports.getStartOfDayDate = exports.getDateTimezone = exports.getFutureTimestampSeconds = exports.getFutureTimestamp = exports.getTimestampSeconds = exports.getTimestamp = exports.millisToSeconds = exports.TIMES = undefined;

var _lodash = require('lodash');

var _fp = require('lodash/fp');

var SECOND = 1000;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var MONTH = DAY * 31;
var YEAR = DAY * 365;

var TIMES = exports.TIMES = {
    SECOND: SECOND,
    MINUTE: MINUTE,
    HOUR: HOUR,
    DAY: DAY,
    MONTH: MONTH,
    YEAR: YEAR
};

var millisToSeconds = exports.millisToSeconds = function millisToSeconds(millis) {
    return Math.floor(millis / TIMES.SECOND);
};
var getTimestamp = exports.getTimestamp = function getTimestamp() {
    return Date.now();
};
var getTimestampSeconds = exports.getTimestampSeconds = (0, _fp.flow)([getTimestamp, millisToSeconds]);
var getFutureTimestamp = exports.getFutureTimestamp = function getFutureTimestamp(millisInFuture) {
    return (0, _fp.flow)([getTimestamp, (0, _fp.add)(millisInFuture)]);
};
var getFutureTimestampSeconds = exports.getFutureTimestampSeconds = function getFutureTimestampSeconds(millisInFuture) {
    return (0, _fp.flow)([getFutureTimestamp(millisInFuture), millisToSeconds]);
};

var getLocalTimezone = (0, _lodash.memoize)(function () {
    return new Date().getTimezoneOffset();
});

var getDateTimezone = exports.getDateTimezone = function getDateTimezone(time) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocalTimezone();

    var localTimezone = getLocalTimezone();
    var userTimezone = timezone || localTimezone;

    var timezoneModifier = (localTimezone - userTimezone) * TIMES.MINUTE;

    return time + timezoneModifier;
};

var getStartOfDayDate = exports.getStartOfDayDate = function getStartOfDayDate(date) {
    var startOfDayDate = new Date(date);
    startOfDayDate.setUTCHours(0);
    startOfDayDate.setUTCMinutes(0);
    startOfDayDate.setUTCSeconds(0);
    startOfDayDate.setUTCMilliseconds(0);
    return startOfDayDate;
};

var getDaysSince = exports.getDaysSince = function getDaysSince(millis1) {
    var millis2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

    var millis11IsStart = millis1 < millis2;
    var start = millis11IsStart ? millis1 : millis2;
    var end = millis11IsStart ? millis2 : millis1;
    return Math.floor((end - start) / TIMES.DAY);
};

var addDays = exports.addDays = function addDays(initialDate, daysToAdd) {
    var updatedDate = new Date(initialDate);
    updatedDate.setDate(updatedDate.getDate() + daysToAdd);
    return updatedDate;
};

var isMoreThan = exports.isMoreThan = function isMoreThan(timeDiff) {
    return function (dateToTest) {
        var comparisonDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

        var time1 = comparisonDate.getTime();
        var time2 = dateToTest.getTime();
        return Math.abs(time1 - time2) > timeDiff;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/timeUtil.js
// module id = 43
// module chunks = 0